import React, { useState, useRef, useEffect } from "react";
import cvFile from "../../assets/CV-Bram-Platier.pdf";
import { trackEvent } from "../../analytics";
import "./terminal.css";

const Terminal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [history, setHistory] = useState([
    { text: "Bram Platier IT Portfolio CLI [Version 1.0.0]", type: "system" },
    { text: "Type 'help' to see all available commands.", type: "info" }
  ]);
  const [inputVal, setInputVal] = useState("");
  const terminalEndRef = useRef(null);
  const inputRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => inputRef.current?.focus(), 100);
    }
  }, [isOpen]);

  useEffect(() => {
    terminalEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [history]);

  const handleCommand = (e) => {
    e.preventDefault();
    const cmd = inputVal.trim().toLowerCase();
    if (!cmd) return;

    trackEvent({
      eventType: "terminal_command",
      path: "/terminal",
      pageTitle: document.title,
      targetText: `CLI: ${cmd}`,
      targetTag: "TERMINAL"
    });

    const newHistory = [...history, { text: `bram@portfolio:~$ ${inputVal}`, type: "command" }];

    switch (cmd) {
      case "help":
        newHistory.push(
          { text: "Beschikbare commando's:", type: "info" },
          { text: "  whoami    - Korte introductie over Bram", type: "output" },
          { text: "  skills    - Overzicht van vaardigheden & tech stack", type: "output" },
          { text: "  projects  - Bekijk recente werken en applicaties", type: "output" },
          { text: "  contact   - Toon contactgegevens (email, linkedin)", type: "output" },
          { text: "  cv        - Download het actuele CV (PDF)", type: "output" },
          { text: "  clear     - Wis het terminal scherm", type: "output" },
          { text: "  exit      - Sluit de terminal", type: "output" }
        );
        break;

      case "whoami":
        newHistory.push(
          { text: "Bram Platier", type: "info" },
          { text: "Student Bachelor ICT @ Fontys Hogeschool Eindhoven", type: "output" },
          { text: "Ex-Network Engineering student @ Summa College", type: "output" },
          { text: "Passie voor Cloud, DevOps, Cyber Security & Netwerk Infrastructure", type: "output" }
        );
        break;

      case "skills":
        newHistory.push(
          { text: "Tech Stack & Expertise:", type: "info" },
          { text: "  Frontend: React, JavaScript, CSS3, HTML5", type: "output" },
          { text: "  Backend:  Node.js, Go, Python, REST APIs", type: "output" },
          { text: "  DevOps:   Docker, Proxmox LXC, CI/CD, Ansible, Kubernetes, Terraform", type: "output" },
          { text: "  Network:  Routing/Switching, Firewalls, VPN, Caddy", type: "output" }
        );
        break;

      case "projects":
        newHistory.push(
          { text: "Uitgelichte Projecten:", type: "info" },
          { text: "  1. Ansible Automation & vSphere Pipeline", type: "output" },
          { text: "  2. Multi-Cluster Kubernetes Platform (HPA)", type: "output" },
          { text: "  3. RS Competitions Broadcast Layer (rscompetitions.org)", type: "output" },
          { text: "  4. Kerasjiek Kapperszaak & Maatwerk CMS", type: "output" },
          { text: "  5. Spotify Vibe Suggester (Gemini AI)", type: "output" },
          { text: "  6. Medieval TD PvP Realtime Game", type: "output" }
        );
        break;

      case "contact":
        newHistory.push(
          { text: "Neem contact op:", type: "info" },
          { text: "  E-mail:   bramplatier@gmail.com", type: "output" },
          { text: "  LinkedIn: linkedin.com/in/bram-platier", type: "output" },
          { text: "  GitHub:   github.com/bramplatier", type: "output" }
        );
        break;

      case "cv":
        newHistory.push({ text: "CV download gestart...", type: "success" });
        const link = document.createElement("a");
        link.href = cvFile;
        link.download = "CV-Bram-Platier.pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        break;

      case "clear":
        setHistory([]);
        setInputVal("");
        return;

      case "exit":
        setIsOpen(false);
        setInputVal("");
        return;

      default:
        newHistory.push({ text: `Command not found: '${cmd}'. Type 'help' for commands.`, type: "error" });
        break;
    }

    setHistory(newHistory);
    setInputVal("");
  };

  return (
    <>
      <button 
        className="terminal__launcher-btn" 
        onClick={() => setIsOpen(true)}
        title="Open Interactive CLI Terminal"
        aria-label="Open Interactive CLI Terminal"
      >
        <span className="terminal__launcher-icon"><i className="fas fa-terminal"></i></span>
        <span className="terminal__launcher-text">CLI</span>
      </button>

      {isOpen && (
        <div className="terminal__overlay" onClick={() => setIsOpen(false)}>
          <div className="terminal__window" onClick={(e) => e.stopPropagation()}>
            <div className="terminal__bar">
              <div className="terminal__bar-left">
                <i className="fas fa-terminal terminal__bar-icon"></i>
                <span className="terminal__title">bram@portfolio: ~ (zsh)</span>
              </div>
              <button 
                className="terminal__close-btn" 
                onClick={() => setIsOpen(false)}
                title="Sluiten"
                aria-label="Sluiten"
              >
                <i className="fas fa-times"></i>
              </button>
            </div>

            <div className="terminal__body" onClick={() => {
              if (window.getSelection().toString().length === 0) {
                inputRef.current?.focus();
              }
            }}>
              {history.map((item, idx) => (
                <div key={idx} className={`terminal__line terminal__line--${item.type}`}>
                  {item.text}
                </div>
              ))}

              <form onSubmit={handleCommand} className="terminal__prompt-line">
                <span className="terminal__prompt">bram@portfolio:~$</span>
                <input
                  ref={inputRef}
                  type="text"
                  className="terminal__input"
                  value={inputVal}
                  onChange={(e) => setInputVal(e.target.value)}
                  placeholder="Type a command (e.g. 'help')..."
                  autoFocus
                />
              </form>
              <div ref={terminalEndRef} />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Terminal;
